import React, { useEffect, useMemo, useState } from 'react';
import { TableViews } from '../constants';
import ViewTableContainer from './viewTableContainer';
import EditTableContainer from './editTableContainer';
import ColumnOrderModal from './columnOrderModal';
import { useSearchDisplayFields } from 'redux/hooks/searchnFilter';
import { SearchDisplayFieldStatus } from 'business/models/Models';

interface Props {
  panelState: TableViews;
  setPanelState: React.Dispatch<React.SetStateAction<TableViews>>;
  customSelectionChange?: (rowIndices: number[]) => void;
  showColumnOrderModal: boolean;
  setShowColumnOrderModal: (flag: boolean) => void;
}
const TableContainer = (props: Props) => {
  const {
    panelState,
    setPanelState,
    customSelectionChange,
    showColumnOrderModal,
    setShowColumnOrderModal,
  } = props;
  const displayFields = useSearchDisplayFields();
  const [columnStatus, setColumnStatus] = useState<{ [columnName: string]: boolean }>({});

  const columns = useMemo(
    () =>
      displayFields
        ?.filter((sf) => sf.status === SearchDisplayFieldStatus.Display)
        .map((sf) => sf.columnHeader),
    [displayFields],
  );
  const [columnOrder, setColumnOrder] = useState<string[]>(columns);
  //Guard Clause
  if (columns.length === 0) {
    return <></>;
  }
  useEffect(() => {
    const columnMap = {};
    let count = 0;
    columns.forEach((column) => {
      columnMap[column] = count < 3 ? true : false;
      count += 1;
    });
    setColumnStatus(columnMap);
  }, [columns]);

  useEffect(() => {
    setColumnOrder(columns);
  }, [columns]);

  const orderedVisibleColumns = columnOrder.filter(
    (columnName) => columnStatus[columnName] === true,
  );

  const onConfirmColumnOrder = (newVisibleOrder: string[]) => {
    const hiddenColumns = columnOrder.filter(
      (columnName) => columnStatus[columnName] !== true,
    );
    setColumnOrder([...newVisibleOrder, ...hiddenColumns]);
  };

  return (
    <div id="searchandfilter-table-tablecontainer" className="flex flex-col">
      {panelState === TableViews.VIEW_TABLE && (
        <ViewTableContainer
          columns={columnStatus}
          columnOrder={columnOrder}
          customSelectionChange={customSelectionChange}
        />
      )}
      {panelState === TableViews.EDIT_TABLE && (
        <EditTableContainer
          id="snf-tablecontainer-edittable"
          columns={columnStatus}
          setColumnStatus={setColumnStatus}
          setPanelState={setPanelState}
        />
      )}
      <ColumnOrderModal
        showModal={showColumnOrderModal}
        setShowModal={setShowColumnOrderModal}
        selectedColumns={orderedVisibleColumns}
        onConfirm={onConfirmColumnOrder}
      />
    </div>
  );
};

export default TableContainer;
